if($('.type-index').length){
    //$('.special-video').insertBefore('.homepage-blog-wrapper')
    //$('html').on('click', '.special-video .background', function(){
    //    $('.special-video .background').hide()
    //    $('.iframe').show()
    //})
    $('.prodejna .inner .kontakty').append($('footer#footer .contact-box li:not(".social-icon-list")').clone())
    $('html').on('click', '.equii-stred .video-iframe', function(){
        $('.equii-stred .video-iframe img').hide()
        $('.equii-stred .video-iframe iframe').show()
    })
    $(document).ready(function(){  
        var myCarousels = $(".carousel");
        myCarousels.each(function( index, element  ) {
          var myCarousel = $("#"+$(element).attr('id')); 
          myCarousel.append("<ol class='carousel-indicators'></ol>");
          var indicators = $("#"+$(element).attr('id') + " .carousel-indicators"); 
          $("#"+$(element).attr('id') +" .carousel-inner").children(".item").each(function(index) {
              console.log(index);
              (index === 0) ? 
              indicators.append("<li data-target='#"+$(element).attr('id')+"' data-slide-to='"+index+"' class='active'></li>") : 
              indicators.append("<li data-target='#"+$(element).attr('id')+"' data-slide-to='"+index+"'></li>");
          });
        });
        var touchStartX = 0;
        var touchEndX = 0;
      
        $(".carousel").on("touchstart", function(event) {
          touchStartX = event.originalEvent.touches[0].clientX;
        });
      
        $(".carousel").on("touchend", function(event) {
          touchEndX = event.originalEvent.changedTouches[0].clientX;
      
          if (touchStartX - touchEndX > 50) {
            $(this).carousel('next');
          } else if (touchEndX - touchStartX > 50) {
            $(this).carousel('prev');
          }
        });
    });
   

    var hp_kategorie = vlastni_kategorie[0].kategorie[0].subkategorie
    for (var l = 0; l <= hp_kategorie.length - 1; l++){
        $('.favorite-categories .fav-wrap').append('<div class="inner"><a href="'+hp_kategorie[l].url+'"></a><div class="image"><img src="'+hp_kategorie[l].obrazek+'"></div><p>'+hp_kategorie[l].nadpis+'</p></div>') 
    }

    if($('.homepage-blog-wrapper').length){
      $('.homepage-blog-wrapper').append('<div class="text-center"><a href="/jezdectvi/" class="btn btn-white-invert">VŠECHNY ČLÁNKY</a></div>')
    }

}

